import { SuggestionListItemNew, SuggestionsList } from './suggestions-list';
import { getProductElementIndex } from './utils/get-element-index';
import React from 'react';
import { NewSuggestion } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

export const DATA_QA_NEW_SUGGESTIONS_LIST = 'product-suggestions';

export type NewSuggestionsListProps = {
  showProducts: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  slicedNewSuggestions: NewSuggestion[];
  searchHref: string;
  index: number;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  isSrp: boolean;
  showOnlyCategories: boolean;
};

export const NewSuggestionsList: React.FC<NewSuggestionsListProps> = ({
  showProducts,
  suggestionSelector,
  slicedNewSuggestions,
  isDefaultList,
  index,
  isSrp,
  searchHref,
  buttonAction,
  showOnlyCategories,
}) => {
  const { t } = useTranslation();

  if (!showOnlyCategories && showProducts) {
    return (
      <SuggestionsList
        suggestionSelector={suggestionSelector}
        withTitle={false}
        withDivider={isDefaultList}
        title={t('header.searchbar.products')}
        aria-label={t('header.searchbar.products-aria')}
        data-qa={DATA_QA_NEW_SUGGESTIONS_LIST}
      >
        {slicedNewSuggestions.map((item, idx) => (
          <SuggestionListItemNew
            newSuggestion={item}
            elementIndex={getProductElementIndex(idx, isDefaultList)}
            navigationIndex={index}
            searchHref={searchHref}
            buttonAction={buttonAction}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            key={item.name}
          />
        ))}
      </SuggestionsList>
    );
  } else {
    return null;
  }
};
